module.exports = "<div class=\"four-zero-four\">\n  <div class=\"four-zero-four-container\">\n      <div class=\"error-code\">403</div>\n      <div class=\"error-message\">ACCESS DENIED</div>\n      <div class=\"\">You do not have permission to view this resource</div>\n      <div class=\"button-place\">\n          <a href=\"#\" [routerLink]=\"['/']\" class=\"btn btn-default btn-lg waves-effect\">GO TO HOMEPAGE</a>\n      </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/errors-pages/access-denied/access-denied.component.html
// module id = ./src/app/errors-pages/access-denied/access-denied.component.html
// module chunks = main